import { CONTACT } from './site';

export const COMPLAINTS_PROVIDER = {
  razonSocial: 'CORPORACION INDEMNIZA SOCIEDAD COMERCIAL DE RESPONSABILIDAD LIMITADA',
  nombreComercial: 'Corporación Indemniza',
  ruc: '20601673224',
  direccion: CONTACT.address,
} as const;

export const COMPLAINTS_CONFIG = {
  endpoint: '/enviar-reclamacion.php',
  privacyNoticeVersion: '2026-09-draft',
  responseBusinessDays: 15,
  maxFiles: 5,
  maxFileBytes: 10 * 1024 * 1024,
  maxTotalFileBytes: 15 * 1024 * 1024,
  allowedMimeTypes: ['application/pdf', 'image/jpeg', 'image/png', 'image/webp'],
} as const;

export const DOCUMENT_TYPES = ['DNI', 'Carné de extranjería', 'Pasaporte', 'RUC', 'Otro'] as const;
export const RECEIPT_TYPES = ['Boleta', 'Factura', 'Recibo', 'Contrato', 'Sin comprobante', 'Otro'] as const;

export type DocumentType = (typeof DOCUMENT_TYPES)[number];
export type ReceiptType = (typeof RECEIPT_TYPES)[number];
export type GoodType = 'Producto' | 'Servicio';
export type ComplaintType = 'Reclamo' | 'Queja';
export type ResponseMedium = 'Correo electrónico' | 'Carta al domicilio';
export type Currency = 'PEN' | 'USD';

export type ReclamationFormValues = {
  nombres: string;
  apellidos: string;
  tipoDocumento: DocumentType;
  numeroDocumento: string;
  telefono: string;
  correo: string;
  direccion: string;
  departamentoId: string;
  departamento: string;
  provinciaId: string;
  provincia: string;
  distritoId: string;
  distrito: string;
  ubigeo: string;
  esMenorEdad: boolean;
  nombresRepresentante: string;
  tipoDocumentoRepresentante: DocumentType;
  numeroDocumentoRepresentante: string;
  telefonoRepresentante: string;
  correoRepresentante: string;
  direccionRepresentante: string;
  tipoBien: GoodType;
  descripcionBienServicio: string;
  fechaAdquisicion: string;
  montoReclamado: string;
  moneda: Currency;
  tipoComprobante: ReceiptType;
  numeroComprobante: string;
  tipoRegistro: ComplaintType;
  detalle: string;
  pedido: string;
  medioRespuesta: ResponseMedium;
  declaracionVeracidad: boolean;
  aceptaPrivacidad: boolean;
  website: string;
};

export const DEFAULT_RECLAMATION_VALUES: ReclamationFormValues = {
  nombres: '',
  apellidos: '',
  tipoDocumento: 'DNI',
  numeroDocumento: '',
  telefono: '',
  correo: '',
  direccion: '',
  departamentoId: '',
  departamento: '',
  provinciaId: '',
  provincia: '',
  distritoId: '',
  distrito: '',
  ubigeo: '',
  esMenorEdad: false,
  nombresRepresentante: '',
  tipoDocumentoRepresentante: 'DNI',
  numeroDocumentoRepresentante: '',
  telefonoRepresentante: '',
  correoRepresentante: '',
  direccionRepresentante: '',
  tipoBien: 'Servicio',
  descripcionBienServicio: '',
  fechaAdquisicion: '',
  montoReclamado: '',
  moneda: 'PEN',
  tipoComprobante: 'Sin comprobante',
  numeroComprobante: '',
  tipoRegistro: 'Reclamo',
  detalle: '',
  pedido: '',
  medioRespuesta: 'Correo electrónico',
  declaracionVeracidad: false,
  aceptaPrivacidad: false,
  website: '',
};
